<section class="content">
  <div class="content-block">
    <div class="admin-card">
      <div class="admin-header">
        <div>
          <h2>Utilisateurs</h2>
          <p>Gestion des utilisateurs du prestataire</p>
        </div>
        <button class="btn btn-primary" (click)="openCreate()">+ Nouvel utilisateur</button>
      </div>

      <div class="toolbar">
        <input class="form-control" [(ngModel)]="searchKey" (keyup.enter)="currentPage = 0; getItems()"
          placeholder="Rechercher par nom, login ou email">
        <button class="btn btn-outline-primary" (click)="currentPage = 0; getItems()">Rechercher</button>
      </div>

      <div class="table-responsive">
        <table class="table table-hover align-middle">
          <thead><tr><th>#</th><th>Utilisateur</th><th>Login</th><th>Email</th><th>Téléphone</th><th>Validité</th><th>Actions</th></tr></thead>
          <tbody>
            <tr *ngFor="let item of items; let i = index">
              <td>{{ currentPage * itemsPerPage + i + 1 }}</td>
              <td><strong>{{ item.nom }} {{ item.prenom }}</strong></td>
              <td>{{ item.login }}</td><td>{{ item.email }}</td><td>{{ item.telephone }}</td>
              <td>{{ item.validity | date:'dd/MM/yyyy' }}</td>
              <td class="actions">
                <button class="btn btn-sm btn-outline-primary" (click)="openEdit(item)">Modifier</button>
                <button class="btn btn-sm btn-outline-secondary" (click)="resetPassword(item)">Mot de passe</button>
                <button class="btn btn-sm btn-outline-danger" (click)="delete(item)">Supprimer</button>
              </td>
            </tr>
            <tr *ngIf="!loading && !items.length"><td colspan="7" class="empty">Aucun utilisateur trouvé</td></tr>
            <tr *ngIf="loading"><td colspan="7" class="empty">Chargement...</td></tr>
          </tbody>
        </table>
      </div>
      <div class="pager">
        <button class="btn btn-sm btn-outline-secondary" [disabled]="currentPage === 0" (click)="currentPage = currentPage - 1; getItems()">Précédent</button>
        <span>Page {{ currentPage + 1 }}</span>
        <button class="btn btn-sm btn-outline-secondary" [disabled]="items.length < itemsPerPage" (click)="currentPage = currentPage + 1; getItems()">Suivant</button>
      </div>
    </div>
  </div>
</section>

<div class="modal-backdrop-custom" *ngIf="showModal" (click)="closeModal()">
  <div class="user-modal" (click)="$event.stopPropagation()">
    <div class="modal-title-row"><h3>{{ itemToSave.id ? 'Modifier' : 'Créer' }} un utilisateur</h3><button (click)="closeModal()">×</button></div>
    <div class="form-grid">
      <label>Nom *<input class="form-control" [(ngModel)]="itemToSave.nom"></label>
      <label>Prénoms *<input class="form-control" [(ngModel)]="itemToSave.prenom"></label>
      <label>Login *<input class="form-control" [(ngModel)]="itemToSave.login"></label>
      <label *ngIf="!itemToSave.id">Mot de passe *<input type="password" class="form-control" [(ngModel)]="itemToSave.password"></label>
      <label>Date de naissance *<input type="date" class="form-control" [max]="maxBirthDate" [(ngModel)]="itemToSave.date_naissance"></label>
      <label>Civilité *<select class="form-select" [(ngModel)]="itemToSave.civilite_id"><option [ngValue]="null">Choisissez</option><option *ngFor="let item of civilites" [ngValue]="item.id">{{ item.libelle }}</option></select></label>
      <label>Genre *<select class="form-select" [(ngModel)]="itemToSave.genre_id"><option [ngValue]="null">Choisissez</option><option *ngFor="let item of genres" [ngValue]="item.id">{{ item.libelle }}</option></select></label>
      <label>Date de validité *<input type="date" class="form-control" [(ngModel)]="itemToSave.validity"></label>
      <label>Email *<input type="email" class="form-control" [(ngModel)]="itemToSave.email"></label>
      <label>Email secondaire<input type="email" class="form-control" [(ngModel)]="itemToSave.email2"></label>
      <label>Téléphone *<input class="form-control" [(ngModel)]="itemToSave.telephone"></label>
      <label>Téléphone secondaire<input class="form-control" [(ngModel)]="itemToSave.telephone2"></label>
    </div>
    <div class="permissions-grid">
      <div><h4>Activités</h4><label class="permission" *ngFor="let item of activites"><input type="checkbox" [(ngModel)]="item.is_checked"> {{ item.activite_libelle }}</label></div>
      <div><h4>Autres activités</h4><label class="permission" *ngFor="let item of autresActivites"><input type="checkbox" [(ngModel)]="item.is_checked"> {{ item.libelle }}</label></div>
    </div>
    <div class="modal-actions"><button class="btn btn-light" (click)="closeModal()">Annuler</button><button class="btn btn-primary" [disabled]="saving" (click)="save()">{{ saving ? 'Enregistrement...' : 'Enregistrer' }}</button></div>
  </div>
</div>
